export default function updateDateLigneCommande(ligneCommande, dateDebut, dateFin) {
  ligneCommande.lignesCommande.forEach((ligneCommande) => {
    ligneCommande.dateDebut = dateDebut;
    ligneCommande.dateFin = dateFin;
  });
}
